import { render, staticRenderFns } from "./batchRecommend.vue?vue&type=template&id=4695665e&"
import script from "./batchRecommend.vue?vue&type=script&lang=ts&"
export * from "./batchRecommend.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports